import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles(() => ({
  skeletonContainer: { width: '100%' },
  skeleton: { width: '100%', height: 60, marginBottom: 20 },
  skeletonRow: { width: '100%', height: 40 },
  root: {
    position: 'relative',
    width: '100%'
  },
  header: {
    display: 'flex',
    justifyContent: 'space-between'
  },
  datePickerContainer: {
    marginTop: 21,
    marginRight: 57,
    width: 282,
    borderRadius: 3,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-end'
  }
}))

export default useStyles
